/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

/**
 * Maps ZenGRC custom attribute types to GraphQL field type.
 *
 * Example: TEXT => string
 */
export enum customAttributeTypeToFieldType {
  TEXT = 'string',
  RICH_TEXT = 'string',
  DATE = 'date',
  INT = 'integer',
  FLOAT = 'float',
  CHECKBOX = 'boolean',
  DROPDOWN = 'string',
  MULTI = 'stringList',
  MAP_PERSON = 'person',
}

/**
 * Maps ZenGRC custom attribute types to GraphQL custom attributes type name.
 */
export const customAttributeTypeToTypeName: { [key: string]: string } = {
  TEXT: 'CustomAttributeString',
  RICH_TEXT: 'CustomAttributeString',
  DATE: 'CustomAttributeDate',
  INT: 'CustomAttributeInt',
  FLOAT: 'CustomAttributeFloat',
  CHECKBOX: 'CustomAttributeBoolean',
  DROPDOWN: 'CustomAttributeString',
  MULTI: 'CustomAttributeStringList',
  MAP_PERSON: 'CustomAttributePerson',
};

/**
 * Returns the type name (`__typename` meta field) for a given custom attribute type.
 */
export function getCustomAttributeGqlTypeName(customAttributeType: string, customAttributeName: string): string {
  // TODO: the hackiest hack, we need to do this better in GQL
  // The CA type returned for dynamic attributes should not be "DYNAMIC", rather
  // we should use "TEXT" and "FLOAT", as this should describe the primitive of
  // it and not provide info on the implementation detail of it (that it is
  // dynamic). This should be exposed by a dedicated field on the attribute,
  // in the same manner as we do for CAs (`isCustomAttribute`) and mappings
  // (`isMapping`).
  if (customAttributeName.includes('dynamic__risk_factor')) {
    return customAttributeTypeToTypeName['TEXT'];
  } else if (customAttributeName.includes('dynamic__risk_score')) {
    return customAttributeTypeToTypeName['FLOAT'];
  } else if (customAttributeName.includes('dynamic__risk_vector')) {
    return customAttributeTypeToTypeName['FLOAT'];
  }

  if (!customAttributeTypeToTypeName.hasOwnProperty(customAttributeType)) {
    throw new Error(`Unable to find GraphQL type name for custom attribute type: ${customAttributeType}`);
  }

  return customAttributeTypeToTypeName[customAttributeType];
}
